// Session-scoped preference: once a user checks "don't ask again this
// session" in the external-link confirmation dialog, we skip the dialog
// for the rest of the tab. Deliberately module-level (not localStorage /
// sessionStorage) so a fresh tab always gets the safety prompt back —
// leaving the app "silently" and coming back should not carry a stale
// "trust everything" preference.

let skipExternalLinkConfirm = false;
const subscribers = new Set();

export const getSkipExternalLinkConfirm = () => skipExternalLinkConfirm;

export const setSkipExternalLinkConfirm = (v) => {
  skipExternalLinkConfirm = Boolean(v);
  subscribers.forEach((fn) => {
    try { fn(skipExternalLinkConfirm); } catch { /* subscriber threw — ignore */ }
  });
};

export const subscribeSkipExternalLinkConfirm = (fn) => {
  subscribers.add(fn);
  return () => subscribers.delete(fn);
};
